import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { PhasrRecommendationsGridDataProviderFactory } from '../factory/PhasrRecommendationsGridDataProviderFactory';
import { PhasrRecommendationsGridBaseDataProvider } from '../dataProvider/PhasrRecommendationsGridBaseDataProvider';
import { ApplyRecommendationPayload } from '../types';

export class PhasrRecommendationsGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PhasrRecommendationsGridDataProviderFactory;
  public dataProvider: PhasrRecommendationsGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PhasrRecommendationsGridDataProviderFactory(),
    });
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }

  public async updateRecommendationBehaviourActions(payload: ApplyRecommendationPayload): Promise<{success: boolean, code?: number}> {
    return this.dataProvider.updateRecommendationBehaviourActions(payload);
  }
}
